import { ChangeEvent, useEffect, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { SfLabelText } from './Filter.style';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { RootState } from '../../store/store';
import { useSelector, useDispatch } from 'react-redux';
import { setZipCode } from 'src/features/coveoSlice';
import ClearIcon from '@mui/icons-material/Cancel';

const ZipcodeFilter = (props): JSX.Element => {
  const data = props?.data;
  const regex = /^\d{5}$/;
  const zipCodeErrorMessage = props?.zipcodeRegexFailedErrorMessage?.value || 'Zipcode Invalid';
  const isZipcodeRequired = props?.isZipcodeRequired?.value === true ? true : false;
  const zipcodeRequiredErrorMessage =
    props?.zipcodeRequiredErrorMessage?.value || 'Zipcode Required';
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const value = useSelector((state: RootState) => state.coveoResult.zipCode);
  useEffect(() => {
    if (isZipcodeRequired) {
      if (value?.length === 0 || value === null || value === '') {
        setError(true);
      }
    }
  }, [isZipcodeRequired, value]);
  const errorMessage =
    isZipcodeRequired && (value?.length === 0 || value === null || value === '')
      ? zipcodeRequiredErrorMessage
      : zipCodeErrorMessage;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length > 5) return;
    dispatch(setZipCode(value));
    if (isZipcodeRequired && (value.length === 0 || value === null || value === '')) {
      setError(true);
    } else if (value?.length > 0 && !regex?.test(value)) {
      setError(true);
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    const zipCode = localStorage.getItem('zipCode');
    if (zipCode) {
      dispatch(setZipCode(zipCode));
    }
    localStorage.removeItem('zipCode');
  }, [dispatch]);

  const handleReset = () => {
    dispatch(setZipCode(''));
    setError(false);
  };
  return (
    <>
      <SfLabelText>
        <Text field={data?.fields?.label}></Text>
      </SfLabelText>
      <TextField
        value={value}
        label=""
        size="small"
        id="outlined-start-adornment"
        sx={{
          width: '100%',
          '& input': { color: (theme) => theme.palette.common.black },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
          },
        }}
        placeholder={data?.fields?.placeholder?.value}
        onChange={onChange}
        error={error}
        helperText={error ? errorMessage : ''}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ color: (theme) => theme.palette.neutral6.main }}>
              <ClearIcon
                style={{
                  cursor: 'pointer',
                  visibility: value ? 'visible' : 'hidden',
                }}
                onClick={handleReset}
              />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default ZipcodeFilter;
